import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye'

import * as S from './styled'

const RowCountPicker = ({ instance: { setPageSize, pageSize }, numberOfRows }) => {
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    const onSetPageSize = value => {
        window.localStorage.setItem(`${user}_pageSize`, value)
        setPageSize(value)
    }

    return (
        <S.RowCountPicker data-testid="rowcount-picker">
            <FontAwesomeIcon icon={faEye} />
            <select
                value={pageSize}
                className="result-dropdown !mx-2"
                onChange={e => onSetPageSize(e.target.value)}
                data-testid="result-number-dropdown"
            >
                <option value="10" data-testid="display-10">
                    10
                </option>
                <option value="25" data-testid="display-25">
                    25
                </option>
                <option value="50" data-testid="display-50">
                    50
                </option>
                <option value="100" data-testid="display-100">
                    100
                </option>
                <option value="1000" data-testid="display-1000">
                    1000
                </option>
            </select>
            entries of {numberOfRows}
        </S.RowCountPicker>
    )
}

export default RowCountPicker
